import { DrawerCloseButton, OrderVehicleReminder } from '@components';
import { useView } from '@hooks';
import { Drawer } from 'antd';
import React from 'react';

interface IProps {
  open: boolean;
  vin: string;
  registrationNumber: string;
  customerId: string;
  currentMileage: number | undefined;
  onClose: () => void;
}

/** The vehicle's service reminders, opened from the customer card - was a tab on the order. */
export const RemindersDrawer: React.FC<IProps> = ({
  open,
  vin,
  registrationNumber,
  customerId,
  currentMileage,
  onClose,
}) => {
  const { isMobile } = useView();

  // Wider than the 720 of a plain drawer: a reminder row carries two inputs and three dated
  // columns, and at 720 the headings wrapped onto two lines. Capped against the window so a small
  // laptop still gets a drawer rather than a full-screen sheet.
  const width = isMobile ? '100%' : 'min(880px, 92vw)';

  return (
    <Drawer
      title="Reminders"
      open={open}
      onClose={onClose}
      styles={{ wrapper: { width } }}
      destroyOnHidden
      closable={false}
      extra={<DrawerCloseButton onClick={onClose} />}
    >
      <OrderVehicleReminder
        vin={vin}
        registrationNumber={registrationNumber}
        customerId={customerId}
        currentMileage={currentMileage}
      />
    </Drawer>
  );
};
